const IndexedDB =
  window.indexedDB ||
  window.mozIndexedDB ||
  window.webkitIndexedDB ||
  window.msIndexedDB;

const DB_NAME = process.env.REACT_APP_DATABASE_NAME || "AppDB";

const DB_VERSION_RAW = parseInt(process.env.REACT_APP_DATABASE_VERSION, 10);
const DB_VERSION = Number.isInteger(DB_VERSION_RAW) && DB_VERSION_RAW > 0 ? DB_VERSION_RAW : 1;

// Create or upgrade the database
export const createDatabase = () => {
  const req = IndexedDB.open(DB_NAME, DB_VERSION);

  req.onupgradeneeded = event => {
    const db = event.target.result;

    // Only create the object store if it's missing
    if (!db.objectStoreNames.contains("branchList"))
      db.createObjectStore("branchList", { keyPath: "id", autoIncrement: true });

    if (!db.objectStoreNames.contains("menuList"))
      db.createObjectStore("menuList", { keyPath: "id", autoIncrement: true });

    if (!db.objectStoreNames.contains("userData"))
      db.createObjectStore("userData", { keyPath: "id", autoIncrement: true });

    if (!db.objectStoreNames.contains("companyList"))
      db.createObjectStore("companyList", { keyPath: "id", autoIncrement: true });
  };

  // Ensure database is fully opened before proceeding
  req.onsuccess = () => {
    console.log("Database created/opened successfully");
  };

  req.onerror = e => console.error("DB open error:", e);
};

// Generic function for database access
export const withDB = (callback) => {
  const request = IndexedDB.open(DB_NAME, DB_VERSION);

  request.onsuccess = () => {
    const db = request.result;

    // Ensure store exists before accessing it
    if (!db.objectStoreNames.contains("branchList") &&
      !db.objectStoreNames.contains("menuList") &&
      !db.objectStoreNames.contains("userData") &&
      !db.objectStoreNames.contains("companyList")) {
      console.error("One or more object stores are missing");
      return;
    }

    callback(db);
  };

  request.onerror = e => console.error("IndexedDB error:", e);
};

// Add data to the database
export const addObjectToDatabase = (objectStore, data) => {
  withDB(db => {
    const tx = db.transaction(objectStore, "readwrite");
    const store = tx.objectStore(objectStore);

    if (Array.isArray(data)) {
      data.forEach(item => store.add(item));
    } else {
      store.add(data);
    }
  });
};

// Get all data from the object store
export const getAllObjectFromDatabase = (objectStore, callback) => {
  withDB(db => {
    const tx = db.transaction(objectStore, "readonly");
    const store = tx.objectStore(objectStore);

    const req = store.getAll();
    req.onsuccess = () => callback(req.result);
  });
};

// Clear all data from the object store
export const clearStoreDataFromDatabase = (objectStore) => {
  withDB(db => {
    const tx = db.transaction(objectStore, "readwrite");
    tx.objectStore(objectStore).clear();
  });
};

// Delete specific data from the object store by key
export const deleteDataFromDatabase = (objectStore, key) => {
  withDB(db => {
    const tx = db.transaction(objectStore, "readwrite");
    tx.objectStore(objectStore).delete(key);
  });
};
